var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTranscriptionButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 24,
    height: 24,
    rx: 4,
    fill: "white",
    stroke: "#1756E8",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3895 10.8542C16.9514 10.8542 16.5755 10.6986 16.262 10.3875C15.9485 10.0764 15.7917 9.69723 15.7917 9.25V5.75C15.7917 5.30277 15.9487 4.92361 16.2629 4.6125C16.577 4.30139 16.9547 4.14584 17.3958 4.14584C17.8431 4.14584 18.2222 4.30139 18.5333 4.6125C18.8444 4.92361 19 5.30277 19 5.75V9.25C19 9.69723 18.8444 10.0764 18.5333 10.3875C18.2222 10.6986 17.8409 10.8542 17.3895 10.8542ZM6.45832 21.5C6.05728 21.5 5.71396 21.3572 5.42838 21.0716C5.14279 20.786 5 20.4427 5 20.0417V5.45832C5 5.05728 5.14279 4.71396 5.42838 4.42838C5.71396 4.14279 6.05728 4 6.45832 4H13.75V5.45832H6.45832V20.0417H16.6667V17.8542H18.125V20.0417C18.125 20.4427 17.9822 20.786 17.6966 21.0716C17.411 21.3572 17.0677 21.5 16.6667 21.5H6.45832ZM8.5 17.8542V16.3958H14.625V17.8542H8.5ZM8.5 15.2292V13.7708H12.875V15.2292H8.5ZM18.125 16.1042H16.6667V13.8583C15.5535 13.6833 14.6189 13.162 13.863 12.2942C13.1071 11.4265 12.7292 10.4118 12.7292 9.25H14.1875C14.1875 10.1347 14.5005 10.8906 15.1264 11.5177C15.7524 12.1448 16.5081 12.4583 17.3936 12.4583C18.2944 12.4583 19.0547 12.1451 19.6745 11.5187C20.2943 10.8924 20.6042 10.1361 20.6042 9.25H22.0625C22.0625 10.4118 21.6882 11.4266 20.9396 12.2943C20.191 13.162 19.2528 13.6833 18.125 13.8583V16.1042Z",
    fill: "#1756E8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTranscriptionButton);
export default __webpack_public_path__ + "static/media/transcriptionButton.9e606baa31e8a17f629c1bbed26af07d.svg";
export { ForwardRef as ReactComponent };